import { CmsProduct } from '../../../../types/cmsProduct';
import { ProductDetailsSectionWrapper } from '../../BaseComponents/ProductDetailsSectionWrapper';
import { ProductDetailsTableKeyValueRow } from '../../BaseComponents/ProductDetailsTableKeyValueRow';
import {
  resolveTiEligibilityEntries,
  TiEligibilityRowConfig,
} from './tiEligibility';

type TiEligibilityListProps = {
  product?: CmsProduct;
  rows?: TiEligibilityRowConfig[];
};

/**
 * TI provider page eligibility list (M6). Renders the editor-configured rows for the active tier's
 * product using the text-capable `ProductDetailsTableKeyValueRow` (NOT the number-only
 * `ProductDetailsAttributeList`, which CC eligibility uses). Rows with no value auto-hide; renders
 * nothing when no row resolves to a value.
 */
export const TiEligibilityList: React.FC<TiEligibilityListProps> = ({
  product,
  rows,
}) => {
  const entries = resolveTiEligibilityEntries(product, rows);

  if (entries.length === 0) return null;

  return (
    <ProductDetailsSectionWrapper>
      <div className="py-spacing/padding/y px-spacing/padding/x flex flex-col gap-spacing/gap/x">
        {entries.map((entry, index) => (
          <ProductDetailsTableKeyValueRow
            // Static config-driven list (no reordering); the index disambiguates
            // rows that resolve to the same attribute key.
            // eslint-disable-next-line react/no-array-index-key
            key={`${entry.key}-${index}`}
            label={entry.label}
            value={entry.value}
            hiddenBorder={index === entries.length - 1}
          />
        ))}
      </div>
    </ProductDetailsSectionWrapper>
  );
};
